import { useContext } from 'react';

import { XmarkIcon } from '@dynatrace/strato-icons';

import * as baseInputStyles from './BaseInput.sty.js';
import { BaseInputContext } from './contexts/BaseInputContext.js';
import { Button } from '../../buttons/button/Button.js';

export const ClearButton = ({ onClear }: { onClear: VoidFunction }) => {
  const { hasError, disabled, ariaDisabled } = useContext(BaseInputContext);
  const disabledOrAriaDisabled = disabled || ariaDisabled || false;

  return (
    <Button
      onClick={onClear}
      className={baseInputStyles.reservedSuffixButton}
      color={hasError ? 'critical' : 'neutral'}
      disabled={disabledOrAriaDisabled}
      data-dt-name="ClearAll"
    >
      <XmarkIcon />
    </Button>
  );
};
